const getUserRoles = (allRoles: string[], Roles: string[]) => {
  const userRoles: { [role: string]: boolean } = {}

  if (Roles.find((v) => v === 'SuperAdmin')) {
    allRoles.forEach((role) => {
      userRoles[role] = true
    })
  } else {
    Roles.forEach((role) => {
      userRoles[role] = true
    })
  }

  return userRoles
}

export default getUserRoles
